import { useCallback, useState } from 'react'

/**
 * Returns hover state and handlers for a single element.
 * Use one call per hoverable zone to avoid multiple useState + onMouseEnter/onMouseLeave.
 */
export function useHoverState(initial = false): {
  isHovered: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
  hoverProps: { onMouseEnter: () => void; onMouseLeave: () => void }
} {
  const [isHovered, setIsHovered] = useState(initial)

  const onMouseEnter = useCallback(() => setIsHovered(true), [])
  const onMouseLeave = useCallback(() => setIsHovered(false), [])

  return {
    isHovered,
    onMouseEnter,
    onMouseLeave,
    hoverProps: { onMouseEnter, onMouseLeave },
  }
}
